if (document.getElementById('prices')) {
    new Vue({
        el: '#prices',
        data: {
            tableName: 'covid19',
            activeClass: 'active',
            Lang
        },
        methods: {
            changeTable(tableName) {
                // this.tableName = tableName;
                if (document.documentElement.clientWidth <= 991) {
                    this.tableName == tableName ? this.tableName = '' : this.tableName = tableName;
                }
                else {
                    this.tableName = tableName;
                }
            }
        },
        mounted() {
            //check on mobile devices
            if (document.documentElement.clientWidth <= 991) {
                this.tableName = '';
                this.activeClass = '';
            }

            jQuery(window).resize(function () {
                if (document.documentElement.clientWidth <= 991) {
                    this.tableName = '';
                    this.activeClass = '';
                }
            });


        }
    });
}

import ServicePage from "../components/service/ServicePage";
import ServicesBlock from "../components/service/ServicesBlock";
import ServicesList from "../components/service/ServicesList";
import ServiceSearch from "../components/service/ServiceSearch";
import SearchServicesList from "../components/service/SearchServicesList";
import ServiceMainSearch from "../components/service/ServiceMainSearch.vue";

if (document.getElementById('service-page')) {
    new Vue({
        el: '#service-page',
        components: {
            ServicePage
        },
    });
}

if (document.getElementById('services-block')) {
    new Vue({
        el: '#services-block',
        components: {
            ServicesBlock
        },
    });
}

if (document.getElementById('services-list')) {
    new Vue({
        el: '#services-list',
        components: {
            ServicesList
        },
    });
}

if (document.getElementById('service-search')) {
    new Vue({
        el: '#service-search',
        components: {
            ServiceSearch
        },
    });
}

if (document.getElementById('service-main-search')) {
    new Vue({
        el: '#service-main-search',
        components: {
            ServiceMainSearch
        },
    });
}

if (document.getElementById('search-services-list')) {
    new Vue({
        el: '#search-services-list',
        components: {
            SearchServicesList
        },
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/snippets/prices.js